import React from "react";
import ReactDOM from "react-dom/client";
import "../src/Assets/css/style.css";
import "../src/Assets/css/plugins.css";
import "../src/Assets/css/cs-style.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
